import { render, staticRenderFns } from "./Embed.vue?vue&type=template&id=476793d8&scoped=true"
import script from "./Embed.vue?vue&type=script&lang=js"
export * from "./Embed.vue?vue&type=script&lang=js"
import style0 from "./Embed.vue?vue&type=style&index=0&id=476793d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476793d8",
  null
  
)

export default component.exports